module.exports = __webpack_public_path__ + "img/pic_480770.4070bf27.jpg";